import React from 'react';
import QuestionLabel from './QuestionLabel';

const YesnoQuestion = ({ value, label, setValue, settings, id }) => {
    return (
        <div>
            <QuestionLabel label={label} settings={settings} />
            <label className="block">
                <input
                    className="mr-2"
                    type="radio"
                    name={id}
                    value="yes"
                    checked={value === 'yes'}
                    onChange={e => setValue(e.target.value)}
                />
                Yes
            </label>
            <label className="block">
                <input
                    className="mr-2"
                    type="radio"
                    name={id}
                    value="no"
                    checked={value === 'no'}
                    onChange={e => setValue(e.target.value)}
                />
                No
            </label>
        </div>
    );
};

export default YesnoQuestion;
